const features = [
  {
    icon: 'ri-flashlight-line',
    title: '实时追踪',
    desc: '7×24小时不间断追踪全网51吃瓜爆料与黑料动态，第一时间汇总最新消息，让你永远快人一步。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量汇总',
    desc: '汇集2000+条51吃瓜黑料汇总与爆料合集，覆盖娱乐圈、网红圈等热门领域，一个网站看遍全网吃瓜。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方核实',
    desc: '每条51吃瓜最新爆料均标注信息来源，坚持多方交叉验证，为吃瓜群众提供更可靠的内容参考。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12">
          为什么选择51吃瓜最新网址
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
          {features.map((f, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center"
            >
              <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4 rounded-full bg-primary-100 text-primary-500">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}